import { Component, OnInit, TrackByFunction, inject } from '@angular/core';

import { isNullOrUndefined } from '@abp/ng.core';
import { BreadcrumbComponent, NavItem, NavItemsService } from '@abp/ng.theme.shared';
import { Observable } from 'rxjs';

import { EnvironmentIndicatorComponent } from '../environment-indicator/environment-indicator.component';
import { MessageInboxComponent } from '../message-inbox/message-inbox.component';
import { SystemDetailsComponent } from '../system-details/system-details.component';

@Component({
  selector: 'nexweb-nav-items',
  templateUrl: './nav-items.component.html',
  imports: [BreadcrumbComponent, SystemDetailsComponent, EnvironmentIndicatorComponent],
})
export class NavItemsComponent implements OnInit {
  private navItemService = inject(NavItemsService);

  private readonly _messageInboxId = 'MessageInboxComponent';
  // private readonly _languagesId = 'Theme.LanguagesComponent';

  private messageInboxNavItem: NavItem = {
    id: this._messageInboxId,
    component: MessageInboxComponent,
    order: 99.99,
  };
  // private languagesNavItemComponent: NavItem = {
  //   id: this._languagesId,
  //   component: LanguagesComponent,
  // };

  private _navItems: NavItem[] = [];

  ngOnInit(): void {
    const messageInbox = this.navItemService.items.find((x) => x.id === this._messageInboxId);
    if (isNullOrUndefined(messageInbox)) {
      this._navItems.push(this.messageInboxNavItem);
    }

    this.navItemService.addItems(this._navItems);
  }

  trackByFn: TrackByFunction<NavItem> = (_, element) => element?.id;

  public getNavItems$(): Observable<NavItem[]> {
    return this.navItemService.items$;
  }
}
